import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import { loadDataFilterConfig } from "features/shared/helpers/modules";
import { getRouteParams } from "features/shared/helpers/routeParams";

import ContractProcessHeader from "../components/ContractProcessHeader";
import ContractProcessCard from "../components/ContractProcessCard";
import ContractProcessNoContentAlert from "../components/ContractProcessNoContentAlert";
import { ContractProcessDTO } from "../dtos/ContractProcessDTO";

import IRepository from "data/IRepository";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import IExternalFilterData from "features/shared/components/dataFilter/IExternalFilterData";
import { Customer_ProcessState, Customer_ContractProcess } from "data/endpoints";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";

type ContractProcessItem = NonNullable<ContractProcessDTO["result"]>[number];

const contractProcessDataFilterJson = loadDataFilterConfig("contractProcessDataFilter");

const ContractProcessSection = () => {
  // DI
  const processStateRepo = useInjection<IRepository<string>>(IocTypes.Repository);

  // STORE
  const customer = useSelector<IAppState, CustomerState>((s) => s.customer).customer;
  const customerId = customer?.customerId;

  // STATE
  const [externalFilterData, setExternalFilterData] = useState<IExternalFilterData<any>[]>([]);

  const getExternalFilterData = async () => {
    if (!customerId) {
      setExternalFilterData([]);
      return;
    }

    const processStates = await processStateRepo.get({
      url: Customer_ProcessState,
      routeParams: getRouteParams("customerId", customerId),
    });

    const options = (processStates ?? []).map((s) => ({ code: s, name: s }));

    setExternalFilterData([
      { name: "ProcessState", data: options },
    ]);
  };

  useEffect(() => {
    getExternalFilterData();
  }, [customerId]);

  return (
    <DataGrid<ContractProcessItem>
      gridId={DataGridId.contractProcessGrid}
      url={Customer_ContractProcess}
      filterJson={contractProcessDataFilterJson}
      filterExternalData={externalFilterData}
      renderHeader={() => <ContractProcessHeader />}
      renderItem={(item) => <ContractProcessCard contractProcess={item} />}
      renderNoContent={() => <ContractProcessNoContentAlert />}
      itemAsCard={false}
      noFilterQueryParams={new URLSearchParams({})}
    />
  );
};

export default ContractProcessSection;
